import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        // Never retry auth / forbidden / payment required
        const status = (error as { status?: number })?.status;
        if (status === 401 || status === 403 || status === 402) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});

/** Canonical query keys — use everywhere to keep invalidation consistent. */
export const queryKeys = {
  subscription: ["subscription"] as const,
  pricing: ["subscription", "pricing"] as const,
  scenarios: ["scenarios"] as const,
  players: ["players"] as const,
  player: (id: number) => ["players", id] as const,
  playerPortfolio: (id: number) => ["players", id, "portfolio"] as const,
  playerLoans: (id: number) => ["loans", "player", id] as const,
  playerHistory: (id: number) => ["game", id, "history"] as const,
  banks: ["loans", "banks"] as const,
  marketplace: (filters: Record<string, unknown>) => ["marketplace", filters] as const,
  property: (id: number) => ["marketplace", id] as const,
  promoCodes: ["admin", "promo-codes"] as const,
};
